var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"show-wrapper",on:{"click":_vm.clickHandler}},[_c('p',{staticClass:"paragraph-s"},[_vm._v(_vm._s(_vm.moreLessLabel))]),_c('svg-icon',{attrs:{"name":_vm.iconName,"width":"12","height":"12"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }